import { createClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

// Suppress Supabase Navigator LockManager warnings
// This is a known issue when Web Locks API is not available or blocked by CSP
const originalConsoleWarn = console.warn;
console.warn = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  if (message.includes('Navigator LockManager') || message.includes('lock:sb-auth-token')) {
    // Suppress this specific warning - auth will work without locks
    return;
  }
  originalConsoleWarn.apply(console, args);
};

export const supabase = createClient(
  environment.supabaseUrl, 
  environment.supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'sb-auth-token',
      flowType: 'pkce'
    }
  }
);
